// removed by extract-text-webpack-plugin
module.exports = {"errorSummary":"errorSummary__B441b","propKey":"propKey__2-j7j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/errorSummary/style.scss
// module id = 358
// module chunks = 0